import React from "react";
import { UserSearch } from "../../components/userSearch";
import { addressData } from "../../components/addAddress/addressData";
import AddressBlock from "../../components/addAddress/addressBlock";
import OrderCard from "../../components/pastOrders";
import { orders } from "../../components/pastOrders/ordersData";
import { AvailableBrands } from "../../components/availableBrands";

export const ActiveOrder = () => {
  return (
    <>
      <UserSearch showDetails />
      <div className="sm:flex flex-wrap px-4 ">
        {addressData.map((address, index) => (
          <AddressBlock
            key={index}
            {...address}
            isLogoBlockVisible={index === addressData.length - 1}
            isAddressBlockVisible
          />
        ))}
      </div>
      <h1 className="text-3xl font-bold text-gray-500 px-4">Past Orders</h1>
      <div className="flex flex-wrap gap-4 my-4 px-4">
        {orders.map((order, index) => (
          <OrderCard
            key={index}
            restaurant={order.restaurant}
            branchName={order.branch_name}
            date={order.date}
            items={order.items}
            total={order.total}
            status={order.status}
            isFirstCard={index === 0} 
          />
        ))}
      </div>
      <AvailableBrands />
    </>
  );
};
